import React from 'react';
import { Button } from '@beehive/components';
import { isBlank } from 'utils/index';

const Bottom = (props: any) => {
  const { loading, onSubmit, formData = {}, requiredKeys = [] } = props;
  const disabled = requiredKeys.some((key: string) => {
    return isBlank(formData[key])
  });
  return (
    <React.Fragment>
      <span className="button-list">
        <Button
          loading={loading}
          disabled={disabled || formData?.boost === 0}
          size="large"
          className="pull-right"
          type="primary"
          onClick={onSubmit}
        >
          提交
        </Button>
      </span>
    </React.Fragment>
  );
};

export default Bottom;
